import { render, staticRenderFns } from "./JRCPSD.vue?vue&type=template&id=978101b4"
import script from "./JRCPSD.vue?vue&type=script&lang=js"
export * from "./JRCPSD.vue?vue&type=script&lang=js"
import style0 from "./JRCPSD.vue?vue&type=style&index=0&id=978101b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports